var functions = require('./functions.js');
var Themeparks = require('themeparks');
var moment = require('moment-timezone');
import MicroModal from 'micromodal';

MicroModal.init();

moment.tz.setDefault('America/New_York');

export function addAllParksFilter() {
    // Get filter bar
    var filterBar = document.getElementById('filterBar');

    // Create button
    var filterButton = document.createElement('button');

    filterButton.innerHTML = 'Alles';

    filterButton.setAttribute('data-filter', 'all');
    filterButton.classList.add('active');

    // Add click event
    filterButton.addEventListener('click', () => {
        document.querySelectorAll('#filterBar button').forEach(btn => btn.classList.remove('active'));
        filterButton.classList.add('active');
        functions.filterParks(filterButton.dataset.filter);

        // Scroll to top
        window.scrollTo(0, 0);
    });

    // Add button
    filterBar.appendChild(filterButton);
}

export function addDestinationFilter(destination) {
    // Get filter bar
    var filterBar = document.getElementById('filterBar');

    // Create button
    var filterButton = document.createElement('button');

    filterButton.innerHTML = functions.shortenDestinationName(destination);

    filterButton.setAttribute('data-filter', destination.slug);

    // Add click event
    filterButton.addEventListener('click', () => {
        document.querySelectorAll('#filterBar button').forEach(btn => btn.classList.remove('active'));
        filterButton.classList.add('active');
        functions.filterParks(filterButton.dataset.filter);

        // Scroll to top
        window.scrollTo(0, 0);
    });

    // Add button
    filterBar.appendChild(filterButton);
}

export function addDestinationParksWaitingTimes(destination) {
    destination.parks.forEach(function (park) {
        // Create park section
        var parkSection = document.createElement('section');

        parkSection.classList.add('park-section');
        parkSection.classList.add(destination.slug);
        parkSection.setAttribute('data-park', park.id);

        // Create park header
        var parkHeader = document.createElement('div');

        parkHeader.classList.add('park-header')

        // Create and add park title
        parkTitle(park).then(function (parkTitle) {
            parkHeader.appendChild(parkTitle);

            return parkTitle
        }).then(function (parkTitle) {
            // Create park toggle
            var parkToggle = document.createElement('button')

            parkToggle.classList.add('park-toggle')
            parkToggle.innerHTML = '<i class="bi bi-chevron-up"></i>';

            // Add click event
            parkTitle.querySelector('.park-name').addEventListener('click', function (e) {
                document.querySelectorAll('.park-section[data-park="' + park.id + '"]').forEach(function (parkSection) {
                    parkSection.querySelector('.park-content').classList.toggle('hidden');

                    if (parkSection.querySelector('.park-content').classList.contains('hidden')) {
                        functions.hidePark(park)

                        parkSection.querySelector('.park-toggle').innerHTML = '<i class="bi bi-chevron-down"></i>';
                    } else {
                        functions.unhidePark(park)

                        parkSection.querySelector('.park-toggle').innerHTML = '<i class="bi bi-chevron-up"></i>';
                    }
                })
            });

            parkToggle.addEventListener('click', function (e) {
                document.querySelectorAll('.park-section[data-park="' + park.id + '"]').forEach(function (parkSection) {
                    parkSection.querySelector('.park-content').classList.toggle('hidden');

                    if (parkSection.querySelector('.park-content').classList.contains('hidden')) {
                        functions.hidePark(park)

                        parkSection.querySelector('.park-toggle').innerHTML = '<i class="bi bi-chevron-down"></i>';
                    } else {
                        functions.unhidePark(park)

                        parkSection.querySelector('.park-toggle').innerHTML = '<i class="bi bi-chevron-up"></i>';
                    }
                })
            });

            // Add park toggle
            parkHeader.appendChild(parkToggle)
        })

        // Add park header
        parkSection.appendChild(parkHeader)

        // Create park content
        var parkContent = document.createElement('div');

        parkContent.classList.add('park-content')

        // Get park live data
        addParkLiveData(park, parkContent, ['ATTRACTION']);

        // Add park content
        parkSection.appendChild(parkContent)

        // Add park section
        document.getElementById('waitTimes').appendChild(parkSection);
    });
}

export function addDestinationParksShowTimes(destination) {
    destination.parks.forEach(function (park) {
        // Create park section
        var parkSection = document.createElement('section');

        parkSection.classList.add('park-section');
        parkSection.classList.add(destination.slug);
        parkSection.setAttribute('data-park', park.id);

        // Create park header
        var parkHeader = document.createElement('div');

        parkHeader.classList.add('park-header')

        // Create and add park title
        parkTitle(park).then(function (parkTitle) {
            parkHeader.appendChild(parkTitle);

            return parkTitle
        }).then(function (parkTitle) {
            // Create park toggle
            var parkToggle = document.createElement('button')

            parkToggle.classList.add('park-toggle')
            parkToggle.innerHTML = '<i class="bi bi-chevron-up"></i>';

            // Add click event
            parkTitle.querySelector('.park-name').addEventListener('click', function (e) {
                document.querySelectorAll('.park-section[data-park="' + park.id + '"]').forEach(function (parkSection) {
                    parkSection.querySelector('.park-content').classList.toggle('hidden');

                    if (parkSection.querySelector('.park-content').classList.contains('hidden')) {
                        functions.hidePark(park)

                        parkSection.querySelector('.park-toggle').innerHTML = '<i class="bi bi-chevron-down"></i>';
                    } else {
                        functions.unhidePark(park)

                        parkSection.querySelector('.park-toggle').innerHTML = '<i class="bi bi-chevron-up"></i>';
                    }
                })
            });

            parkToggle.addEventListener('click', function (e) {
                document.querySelectorAll('.park-section[data-park="' + park.id + '"]').forEach(function (parkSection) {
                    parkSection.querySelector('.park-content').classList.toggle('hidden');

                    if (parkSection.querySelector('.park-content').classList.contains('hidden')) {
                        functions.hidePark(park)

                        parkSection.querySelector('.park-toggle').innerHTML = '<i class="bi bi-chevron-down"></i>';
                    } else {
                        functions.unhidePark(park)

                        parkSection.querySelector('.park-toggle').innerHTML = '<i class="bi bi-chevron-up"></i>';
                    }
                })
            });

            // Add park toggle
            parkHeader.appendChild(parkToggle)
        })

        // Add park header
        parkSection.appendChild(parkHeader)

        // Create park content
        var parkContent = document.createElement('div');

        parkContent.classList.add('park-content')

        // Get park live data
        addParkLiveData(park, parkContent, ['SHOW']);

        // Add park content
        parkSection.appendChild(parkContent)

        // Add park section
        document.getElementById('showTimes').appendChild(parkSection);
    });
}

export function addDestinationParksRestaurants(destination) {
    destination.parks.forEach(function (park) {
        // Create park section
        var parkSection = document.createElement('section');

        parkSection.classList.add('park-section');
        parkSection.classList.add(destination.slug);
        parkSection.setAttribute('data-park', park.id);

        // Create park header
        var parkHeader = document.createElement('div');

        parkHeader.classList.add('park-header')

        // Create and add park title
        parkTitle(park).then(function (parkTitle) {
            parkHeader.appendChild(parkTitle);

            return parkTitle
        }).then(function (parkTitle) {
            // Create park toggle
            var parkToggle = document.createElement('button')

            parkToggle.classList.add('park-toggle')
            parkToggle.innerHTML = '<i class="bi bi-chevron-up"></i>';

            // Add click event
            parkTitle.querySelector('.park-name').addEventListener('click', function (e) {
                document.querySelectorAll('.park-section[data-park="' + park.id + '"]').forEach(function (parkSection) {
                    parkSection.querySelector('.park-content').classList.toggle('hidden');

                    if (parkSection.querySelector('.park-content').classList.contains('hidden')) {
                        functions.hidePark(park)

                        parkSection.querySelector('.park-toggle').innerHTML = '<i class="bi bi-chevron-down"></i>';
                    } else {
                        functions.unhidePark(park)

                        parkSection.querySelector('.park-toggle').innerHTML = '<i class="bi bi-chevron-up"></i>';
                    }
                })
            });

            parkToggle.addEventListener('click', function (e) {
                document.querySelectorAll('.park-section[data-park="' + park.id + '"]').forEach(function (parkSection) {
                    parkSection.querySelector('.park-content').classList.toggle('hidden');

                    if (parkSection.querySelector('.park-content').classList.contains('hidden')) {
                        functions.hidePark(park)

                        parkSection.querySelector('.park-toggle').innerHTML = '<i class="bi bi-chevron-down"></i>';
                    } else {
                        functions.unhidePark(park)

                        parkSection.querySelector('.park-toggle').innerHTML = '<i class="bi bi-chevron-up"></i>';
                    }
                })
            });

            // Add park toggle
            parkHeader.appendChild(parkToggle)
        })

        // Add park header
        parkSection.appendChild(parkHeader)

        // Create park content
        var parkContent = document.createElement('div');

        parkContent.classList.add('park-content')

        // Get park live data
        addParkLiveData(park, parkContent, ['RESTAURANT']);

        // Add park content
        parkSection.appendChild(parkContent)

        // Add park section
        document.getElementById('restaurants').appendChild(parkSection);
    });
}

export async function parkTitle(park) {
    // Create title
    var title = document.createElement('h2');

    title.classList.add('park-title');
    title.innerHTML = '<span class="park-name">' + park.name + '</span>';

    // Get park hours string
    await functions.parkHoursStringToday(park, ['OPERATING']).then(function (parkHoursString) {
        // Create park hours
        var parkHours = document.createElement('span');

        parkHours.classList.add('park-hours');
        parkHours.innerHTML = '<i class="clock-icon bi bi-clock"></i>' + parkHoursString;

        // Add open park hours modal
        parkHours.addEventListener('click', async () => {
            MicroModal.show('modal-' + park.id + '-park-hours');
        });

        // Add park hours
        title.appendChild(parkHours);
    })

    return title;
}

export function addParkLiveData(park, parentElement, types = []) {
    var entitiesApi = new Themeparks.EntitiesApi();

    entitiesApi.getEntityLiveData(park.id).then((data) => {
        // Check if live data found
        var liveDataFound = false

        // Add entities
        data.liveData.forEach(function (entity) {
            // Override entity type
            if (entity.id == '1f542745-cda1-4786-a536-5fff373e5964') { // EPCOT - The American Adventure
                entity.entityType = 'SHOW'

                entity.showtimes = functions.operatingHoursToShowTimes(entity)
            } else if (entity.id == '3b7309a5-7b57-4edf-b4e6-36ad958ac21e') { // Animal Kingdom - The Animation Experience at Conservation Station
                entity.entityType = 'SHOW'

                entity.showtimes = functions.operatingHoursToShowTimes(entity)
            }

            // Check entity type
            if (types.includes(entity.entityType)) {
                if (entity.entityType == 'ATTRACTION') {
                    parentElement.appendChild(addEntityAttraction(entity));

                    liveDataFound = true
                } else if (entity.entityType == 'RESTAURANT') {
                    parentElement.appendChild(addEntityRestaurant(entity));

                    liveDataFound = true
                } else if (entity.entityType == 'SHOW' && functions.showIsNotOverYet(entity)) {
                    parentElement.appendChild(addEntityShow(entity));

                    liveDataFound = true
                }
            }
        });

        // Sort entities
        var sortedRides = Array.from(parentElement.querySelectorAll('.ride-card')).sort((a, b) => {
            return parseInt(b.dataset.sorting) - parseInt(a.dataset.sorting);
        });

        var sortedShows = Array.from(parentElement.querySelectorAll('.show-card')).sort((a, b) => {
            return parseInt(a.dataset.sorting) - parseInt(b.dataset.sorting);
        });

        // Voeg ze opnieuw toe aan het container-element in de juiste volgorde
        sortedRides.forEach(item => parentElement.appendChild(item));
        sortedShows.forEach(item => parentElement.appendChild(item));

        // Add empty state
        if (!liveDataFound) {
            var empty = document.createElement('div')

            empty.classList.add('empty-state')
            empty.innerHTML = 'Geen resultaten gevonden'

            parentElement.appendChild(empty)
        }
    }, (error) => {
        console.error(error);
    });
}

export function addEntityAttraction(entity) {
    // Create ride card
    var rideCard = document.createElement('div');

    rideCard.classList.add('ride-card');
    rideCard.setAttribute('data-ride', entity.name);
    rideCard.setAttribute('data-sorting', functions.entitySorting(entity));

    // Create ride top
    var rideTop = document.createElement('div')
    rideTop.classList.add('ride-top')

    // Create ride info
    var rideInfo = document.createElement('div');

    rideInfo.classList.add('ride-info');

    // Create ride name
    var rideName = document.createElement('div');

    rideName.classList.add('ride-name');
    rideName.innerHTML = entity.name;

    // Create ride bottom toggle
    var rideBottomToggle = document.createElement('button')

    rideBottomToggle.classList.add('ride-bottom-toggle')
    rideBottomToggle.innerHTML = '<i class="bi bi-chevron-down"></i>';

    // Add click event
    rideTop.addEventListener('click', function (e) {
        rideCard.querySelector('.ride-bottom').classList.toggle('hidden');

        if (rideCard.querySelector('.ride-bottom').classList.contains('hidden')) {
            rideBottomToggle.innerHTML = '<i class="bi bi-chevron-down"></i>';
        } else {
            rideBottomToggle.innerHTML = '<i class="bi bi-chevron-up"></i>';
        }
    });

    // Add ride bottom toggle
    rideName.appendChild(rideBottomToggle)

    if (entity.operatingHours && entity.operatingHours.length > 0) {
        // Get ride hours
        var operatingHours = [];

        entity.operatingHours.forEach(function (operatingHour) {
            if (operatingHour.type.toUpperCase() == 'OPERATING' || operatingHour.type == 'Performance Time') {
                if (operatingHour.endTime && (moment(operatingHour.startTime).format() != moment(operatingHour.endTime).format())) {
                    operatingHours.push(moment(operatingHour.startTime).format('HH:mm') + ' - ' + moment(operatingHour.endTime).format('HH:mm'));
                } else {
                    operatingHours.push('Vanaf ' + moment(operatingHour.startTime).format('HH:mm'));
                }
            }
        });

        // Create ride hours
        var rideHours = document.createElement('div');

        rideHours.classList.add('ride-hours');
        rideHours.innerHTML = '<i class="clock-icon bi bi-clock"></i>' + operatingHours.join(' & ');
    }

    // Add elements to ride info
    rideInfo.appendChild(rideName);

    if (rideHours) {
        rideInfo.appendChild(rideHours);
    }

    // Create ride live
    var rideLive = document.createElement('div')

    rideLive.classList.add('ride-live')

    // Create wait time
    if (functions.entityStandyByWaitingTime(entity)) {
        var waitTime = document.createElement('div');

        waitTime.classList.add('wait-time');
        waitTime.innerHTML = functions.entityStandyByWaitingTime(entity) + ' min.';
    }

    // Create status
    var status = document.createElement('div');

    status.classList.add('status');
    status.classList.add(entity.status.toLowerCase());
    status.innerHTML = functions.humanReadableEntityStatus(entity.status);

    // Add waiting time and status
    if (waitTime) {
        rideLive.appendChild(waitTime)
    }

    rideLive.appendChild(status)

    // Create ride bottom
    var rideBottom = document.createElement('div')

    rideBottom.classList.add('ride-bottom')
    rideBottom.classList.add('hidden')

    // Create ride bottom left
    var rideBottomLeft = document.createElement('div')

    rideBottomLeft.classList.add('ride-bottom-left')
    rideBottomLeft.innerHTML = 'left'

    // Create ride bottom right
    var rideBottomRight = document.createElement('div')

    rideBottomRight.classList.add('ride-bottom-right')

    if (functions.entityHasQueueReturnTime(entity)) {
        rideBottomRight.appendChild(queueReturnTime(entity))
    }

    if (functions.entityHasQueuePaidReturnTime(entity)) {
        rideBottomRight.appendChild(queuePaidReturnTime(entity))
    }

    if (functions.entityOperatingHours(entity, ['EARLY_ENTRY']).length > 0) {
        functions.entityOperatingHours(entity, ['EARLY_ENTRY']).forEach(function (operatingHour) {
            rideBottomRight.appendChild(entityOperatingHour(operatingHour))
        })
    }

    if (functions.entityHasForecastedWaitingTimes(entity)) {
        rideBottomRight.appendChild(bestTimeToVisit(entity))
    }

    // Add ride bottom left & right
    rideBottom.appendChild(rideBottomLeft)
    rideBottom.appendChild(rideBottomRight)

    // Add ride card children
    rideTop.appendChild(rideInfo);
    rideTop.appendChild(rideLive);

    rideCard.appendChild(rideTop);
    rideCard.appendChild(rideBottom);

    return rideCard;
}

export function addEntityRestaurant(entity) {
    // Create ride card
    var rideCard = document.createElement('div');

    rideCard.classList.add('ride-card');
    rideCard.setAttribute('data-ride', entity.name);
    rideCard.setAttribute('data-sorting', functions.entitySorting(entity));

    // Create ride top
    var rideTop = document.createElement('div')
    rideTop.classList.add('ride-top')

    // Create ride info
    var rideInfo = document.createElement('div');

    rideInfo.classList.add('ride-info');

    // Create ride name
    var rideName = document.createElement('div');

    rideName.classList.add('ride-name');
    rideName.innerHTML = entity.name;

    // Create ride bottom toggle
    var rideBottomToggle = document.createElement('button')

    rideBottomToggle.classList.add('ride-bottom-toggle')
    rideBottomToggle.innerHTML = '<i class="bi bi-chevron-down"></i>';

    // Add click event
    rideTop.addEventListener('click', function (e) {
        rideCard.querySelector('.ride-bottom').classList.toggle('hidden');

        if (rideCard.querySelector('.ride-bottom').classList.contains('hidden')) {
            rideBottomToggle.innerHTML = '<i class="bi bi-chevron-down"></i>';
        } else {
            rideBottomToggle.innerHTML = '<i class="bi bi-chevron-up"></i>';
        }
    });

    // Add ride bottom toggle
    rideName.appendChild(rideBottomToggle)

    if (entity.operatingHours && entity.operatingHours.length > 0) {
        // Get ride hours
        var operatingHours = [];

        entity.operatingHours.forEach(function (operatingHour) {
            if (operatingHour.type.toUpperCase() == 'OPERATING' || operatingHour.type == 'Performance Time') {
                if (operatingHour.endTime && (moment(operatingHour.startTime).format() != moment(operatingHour.endTime).format())) {
                    operatingHours.push(moment(operatingHour.startTime).format('HH:mm') + ' - ' + moment(operatingHour.endTime).format('HH:mm'));
                } else {
                    operatingHours.push('Vanaf ' + moment(operatingHour.startTime).format('HH:mm'));
                }
            }
        });

        // Create ride hours
        var rideHours = document.createElement('div');

        rideHours.classList.add('ride-hours');
        rideHours.innerHTML = '<i class="clock-icon bi bi-clock"></i>' + operatingHours.join(' & ');
    }

    // Add elements to ride info
    rideInfo.appendChild(rideName);

    if (rideHours) {
        rideInfo.appendChild(rideHours);
    }

    // Create ride live
    var rideLive = document.createElement('div')

    rideLive.classList.add('ride-live')

    // Create wait time
    if (functions.entityStandyByWaitingTime(entity)) {
        var waitTime = document.createElement('div');

        waitTime.classList.add('wait-time');
        waitTime.innerHTML = functions.entityStandyByWaitingTime(entity) + ' min.';
    }

    // Create status
    var status = document.createElement('div');

    status.classList.add('status');
    status.classList.add(entity.status.toLowerCase());
    status.innerHTML = functions.humanReadableEntityStatus(entity.status);

    // Add waiting time and status
    if (waitTime) {
        rideLive.appendChild(waitTime)
    }

    rideLive.appendChild(status)

    // Create ride bottom
    var rideBottom = document.createElement('div')

    rideBottom.classList.add('ride-bottom')
    rideBottom.classList.add('hidden')

    // Create ride bottom left
    var rideBottomLeft = document.createElement('div')

    rideBottomLeft.classList.add('ride-bottom-left')
    rideBottomLeft.innerHTML = 'left'

    // Create ride bottom right
    var rideBottomRight = document.createElement('div')

    rideBottomRight.classList.add('ride-bottom-right')

    if (functions.entityHasQueueReturnTime(entity)) {
        rideBottomRight.appendChild(queueReturnTime(entity))
    }

    if (functions.entityHasQueuePaidReturnTime(entity)) {
        rideBottomRight.appendChild(queuePaidReturnTime(entity))
    }

    if (functions.entityOperatingHours(entity, ['EARLY_ENTRY']).length > 0) {
        functions.entityOperatingHours(entity, ['EARLY_ENTRY']).forEach(function (operatingHour) {
            rideBottomRight.appendChild(entityOperatingHour(operatingHour))
        })
    }

    if (functions.entityHasForecastedWaitingTimes(entity)) {
        rideBottomRight.appendChild(bestTimeToVisit(entity))
    }

    // Add ride bottom left & right
    rideBottom.appendChild(rideBottomLeft)
    rideBottom.appendChild(rideBottomRight)

    // Add ride card children
    rideTop.appendChild(rideInfo);
    rideTop.appendChild(rideLive);

    rideCard.appendChild(rideTop);
    rideCard.appendChild(rideBottom);

    return rideCard;
}

export function addEntityShow(entity) {
    // Create show card
    var showCard = document.createElement('div');

    showCard.classList.add('show-card');
    showCard.setAttribute('data-show', entity.name);
    showCard.setAttribute('data-sorting', functions.entitySorting(entity));

    // Create show info
    var showInfo = document.createElement('div');

    showInfo.classList.add('show-info');

    // Create show name
    var showName = document.createElement('div');

    showName.classList.add('show-title');
    showName.innerHTML = entity.name;

    /*
    
    // Create show location
    var showLocation = document.createElement('div');

    showLocation.classList.add('show-location');
    showLocation.innerHTML = 'Locatie';

    */

    // Create show times
    var showTimesElement = document.createElement('div');

    showTimesElement.classList.add('show-times');

    if (entity.showtimes && entity.showtimes.length > 0) {
        // Get show times
        var showTimes = [];

        entity.showtimes.forEach(function (showTime) {
            if (functions.showTimeIsNotOverYet(showTime)) {
                if (showTime.endTime && (moment(showTime.startTime).format() != moment(showTime.endTime).format())) {
                    showTimes.push(moment(showTime.startTime).format('HH:mm') + ' - ' + moment(showTime.endTime).format('HH:mm'));
                } else {
                    showTimes.push(moment(showTime.startTime).format('HH:mm'));
                }
            }
        });

        // Add show times to element
        showTimes.forEach(function (showTime) {
            // Create show time element
            var showTimeElement = document.createElement('div');

            showTimeElement.classList.add('show-time')

            showTimeElement.innerHTML = showTime

            // Add show time element
            showTimesElement.appendChild(showTimeElement)
        });
    } else {
        // Create status
        var status = document.createElement('div');

        status.classList.add('status');
        status.classList.add(entity.status.toLowerCase());
        status.innerHTML = functions.humanReadableEntityStatus(entity.status);
    }

    // Add elements to show info
    showInfo.appendChild(showName);
    // showInfo.appendChild(showLocation);

    if (showTimesElement) {
        showInfo.appendChild(showTimesElement);
    }

    if (status) {
        showTimesElement.appendChild(status);
    }

    // Add show card children
    showCard.appendChild(showInfo);

    return showCard;
}

export function queueReturnTime(entity) {
    // Create row
    var row = document.createElement('div')

    row.classList.add('row')

    if (entity.queue.RETURN_TIME.state == 'AVAILABLE') {
        row.innerHTML = '<p><strong>Lightning Lane:</strong> ' + moment(entity.queue.RETURN_TIME.returnStart).format('HH:mm') + '</p>'
    } else {
        row.innerHTML = '<p><strong>Lightning Lane:</strong> -</p>'
    }

    return row
}

export function queuePaidReturnTime(entity) {
    // Create row
    var row = document.createElement('div')

    row.classList.add('row')

    if (entity.queue.PAID_RETURN_TIME.state == 'AVAILABLE') {
        row.innerHTML = '<p><strong>Lightning Lane:</strong> ' + moment(entity.queue.PAID_RETURN_TIME.returnStart).format('HH:mm') + ' (' + functions.formatPaidReturnPrice(entity) + ')</p>'
    } else {
        row.innerHTML = '<p><strong>Lightning Lane:</strong> -</p>'
    }

    return row
}

export function entityOperatingHour(operatingHour) {
    // Create row
    var row = document.createElement('div')

    row.classList.add('row')

    row.innerHTML = '<p><strong>' + operatingHour.type + ':</strong> ' + operatingHour.hours + '</p>'

    return row
}

export function bestTimeToVisit(entity) {
    // Get lowest forecasted waiting time
    var lowestForecast = functions.lowestForecast(entity)

    // Check if lowest forecasted waiting time is already over
    var lowestForecastIsInPast = moment(lowestForecast.time).isBefore(moment());

    // Create row
    var row = document.createElement('div')

    row.classList.add('row')

    if (lowestForecastIsInPast) {
        row.innerHTML = '<p><strong>Laagste wachttijd:</strong> <s>' + lowestForecast.waitTime + ' min. om ' + moment(lowestForecast.time).format('HH:mm') + '</s></p>'
    } else {
        row.innerHTML = '<p><strong>Laagste wachttijd:</strong> ' + lowestForecast.waitTime + ' min. om ' + moment(lowestForecast.time).format('HH:mm') + '</p>'
    }

    return row
}

export async function addDestinationParksHoursModal(destination) {
    destination.parks.forEach(function (park) {
        // Create modal
        var modal = document.createElement('div')

        modal.classList.add('modal')
        modal.classList.add('micromodal-slide')

        modal.setAttribute('id', 'modal-' + park.id + '-park-hours')
        modal.setAttribute('aria-hidden', 'true')

        // Get park hours
        functions.parkHoursForToday(park, ['OPERATING', 'TICKETED_EVENT', 'PRIVATE_EVENT', 'EXTRA_HOURS', 'INFO']).then(function (parkHours) {
            // Format park hours
            var formattedParkHours = [];

            parkHours.forEach( function(parkHour) {
                if(parkHour.description) {
                    formattedParkHours.push( '<p><strong>' + functions.humanReadableScheduleType(parkHour.type) + ' (' + parkHour.description + '):</strong> ' + parkHour.hours + '</p>' )
                } else {
                    formattedParkHours.push( '<p><strong>' + functions.humanReadableScheduleType(parkHour.type) + ':</strong> ' + parkHour.hours + '</p>' )
                }
            } );

            // Set content
            modal.innerHTML = `<div class="modal__overlay" tabindex="-1" data-micromodal-close>
                <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-${park.id}-title">
                    <header class="modal__header">
                        <h2 class="modal__title" id="modal-${park.id}-title">
                            ${park.name}
                        </h2>
                        
                        <button class="modal__close" aria-label="Close modal" data-micromodal-close></button>
                    </header>

                    <main class="modal__content" id="modal-${park.id}-content">
                        ${formattedParkHours.join('')}
                    </main>
                </div>
            </div>`

            // Add modal
            document.querySelector('body').appendChild(modal)
        })
    });
}